import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Transfer18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_719)'>
      <path
        d='M14.1895 5.75H2.00012V4.25H14.1895L11.9698 2.03033L13.0304 0.969666L17.0608 5L13.0304 9.03033L11.9698 7.96967L14.1895 5.75Z'
        fill='currentColor'
      />
      <path
        d='M3.81077 12.25L6.03044 10.0303L4.96978 8.96967L0.939453 13L4.96978 17.0303L6.03044 15.9697L3.81078 13.75H16.0001V12.25H3.81077Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_719'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Transfer18.displayName = 'Transfer18';
export default Transfer18;
